import { api } from '@/api/client';
import { pickMediaUrl } from '@/api/mappers/media';
function mapCategory(r) {
    const imageUrl = pickMediaUrl(r.media, 'pathThumb', 'path');
    const imageUrlCard = pickMediaUrl(r.media, 'pathDetail', 'pathCard', 'path', 'pathThumb');
    return {
        id: r.id,
        name: r.name,
        imageUrl,
        ...(imageUrlCard ? { imageUrlCard } : {}),
    };
}
export async function fetchCategoriesForMenu(menuId) {
    const { data } = await api.get(`/v1/menus/${menuId}/categories`);
    return data.map(mapCategory);
}
